var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"icon icon-desapacho_aeronaves"})
}
var staticRenderFns = []

export { render, staticRenderFns }